export const translations = {
  // ENGLISH
  en: {
    nav: {
      home: 'Home',
      tours: 'Tours',
      about: 'About Us',
      gallery: 'Gallery',
      testimonials: 'Testimonials',
      contact: 'Contact',
      quote: 'Request Quote'
    },
    hero: {
      title: 'Welcome to Dream Tour',
      subtitle: 'Your gateway to the wonders of the Red Sea and Egypt',
      cta: 'Explore Our Tours',
      whatsapp: 'Contact on WhatsApp'
    },
    tours: {
      title: 'Our Excursions',
      subtitle: 'Choose Your Next Adventure',
      clickInfo: 'Click on the Icons to view the complete catalog',
      downloadCatalog: 'Download Complete Catalog',
      requestQuote: 'Request a Quote',
      seaTours: {
        title: 'Sea Adventures',
        tours: [
          {
            name: 'Swimming with Dolphins',
            description: 'An incredible experience swimming with dolphins in their natural habitat',
            icon: 'dolphin'
          },
          {
            name: 'Sea Turtle Encounter',
            description: 'Discover the wonderful sea turtles in the crystal-clear waters of the Red Sea',
            icon: 'turtle'
          },
          {
            name: 'White Sand Islands',
            description: 'Visit paradisiacal white sand islands with turquoise waters',
            icon: 'island'
          },
          {
            name: 'Dugong Spotting',
            description: 'A unique adventure to spot the rare dugongs of the Red Sea',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Desert Adventures',
        tours: [
          {
            name: 'Super Safari',
            description: 'Exciting desert adventure with quad or buggy',
            icon: 'desert'
          },
          {
            name: 'Tour in History',
            description: 'Discover the wonders of ancient Egypt with guided tours',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'About Us',
      subtitle: 'Your Reference Point in Marsa Alam',
      description: 'We are an officially registered agency that collaborates with CDWS certified partners. Thanks to long experience and deep passion for Egypt and the Red Sea, we have been creating adventures destined to remain in the heart for years.',
      features: [
        {
          title: 'Expert Guides',
          description: 'Multilingual guides with deep local knowledge'
        },
        {
          title: 'Safety First',
          description: 'Maximum safety standards for all excursions'
        },
        {
          title: 'Best Prices',
          description: 'Competitive prices without compromising quality'
        },
        {
          title: 'Personalized Service',
          description: 'Every excursion tailored to your needs'
        }
      ]
    },
    gallery: {
      title: 'Our Gallery',
      subtitle: 'A Glimpse of Your Next Adventure'
    },
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'Real Experiences from Real Travelers',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Italy',
          rating: 5,
          text: 'We chose DREAM TOUR MARSA ALAM to organize our excursions in Marsa Alam (Super Safari, Hamata and Port Ghalib) and we couldn\'t have made a better choice! You can immediately see that they work with great passion: always available, very kind and ready to answer every question promptly! The organization was impeccable: from the breathtaking Safari to the boat trip to Hamata, everything was taken care of down to the smallest detail. Thanks to Karina we lived unforgettable experiences in total serenity. Highly recommended❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Italy',
          rating: 5,
          text: 'We relied on DREAM TOUR MARSA ALAM for all our excursions and we couldn\'t have made a better choice. At Marsa Mubarak we saw dolphins and swam with a dugong and sea turtles. Luxor was magical, thanks to Hassan\'s supervision. The Super Safari was also a beautiful excursion. Karina was excellent: always super attentive and available for any question. Without her and her excursions our vacation would not have been the same and every excursion is worth every penny spent.'
        },
        {
          name: 'Paola Franci',
          location: 'Italy',
          rating: 5,
          text: 'Yesterday we did the excursion to Wadi El Gemal organized by DREAM TOUR MARSA ALAM. We met dolphins, swam with them, reached the sandbanks and swam in a crystal clear sea. We met a turtle, explored a rich and colorful reef, ate an excellent lunch. A magnificent day. Our guide allowed two guys who couldn\'t swim to snorkel! Rating TEN OUT OF TEN!!! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We Are Here to Help Plan Your Adventure',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Message',
        success: 'Message sent successfully! We will contact you soon.',
        error: 'Error sending message. Please try again.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Facebook Group'
      }
    },
    footer: {
      rights: 'All rights reserved',
      followUs: 'Follow Us'
    }
  },
  // ITALIAN
  it: {
    nav: {
      home: 'Home',
      tours: 'Escursioni',
      about: 'Chi Siamo',
      gallery: 'Galleria',
      testimonials: 'Recensioni',
      contact: 'Contatti',
      quote: 'Richiedi Preventivo'
    },
    hero: {
      title: 'Benvenuti in Dream Tour',
      subtitle: 'La tua porta d\'accesso alle meraviglie del Mar Rosso e dell\'Egitto',
      cta: 'Esplora le Nostre Escursioni',
      whatsapp: 'Contattaci su WhatsApp'
    },
    tours: {
      title: 'Le Nostre Escursioni',
      subtitle: 'Scegli la Tua Prossima Avventura',
      clickInfo: 'Clicca sulle Icone per visionare il catalogo completo',
      downloadCatalog: 'Scarica il Catalogo Completo',
      requestQuote: 'Richiedi un Preventivo',
      seaTours: {
        title: 'Avventure Marine',
        tours: [
          {
            name: 'Nuoto con i Delfini',
            description: 'Un\'esperienza incredibile nuotando con i delfini nel loro habitat naturale',
            icon: 'dolphin'
          },
          {
            name: 'Incontro con le Tartarughe Marine',
            description: 'Scopri le meravigliose tartarughe marine nelle acque cristalline del Mar Rosso',
            icon: 'turtle'
          },
          {
            name: 'Isole di Sabbia Bianca',
            description: 'Visita le paradisiache isole di sabbia bianca con acque turchesi',
            icon: 'island'
          },
          {
            name: 'Avvistamento Dugonghi',
            description: 'Un\'avventura unica per avvistare i rari dugonghi del Mar Rosso',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Avventure nel Deserto',
        tours: [
          {
            name: 'Super Safari',
            description: 'Avventura emozionante nel deserto con quad o buggy',
            icon: 'desert'
          },
          {
            name: 'Tour nella Storia',
            description: 'Scopri le meraviglie dell\'antico Egitto con tour guidati',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'Chi Siamo',
      subtitle: 'Il Tuo Punto di Riferimento a Marsa Alam',
      description: 'Siamo un\'agenzia ufficialmente registrata che collabora con partner certificati CDWS. Grazie a una lunga esperienza e alla profonda passione per l\'Egitto e il Mar Rosso, creiamo da anni avventure destinate a restare nel cuore.',
      features: [
        {
          title: 'Guide Esperte',
          description: 'Guide multilingue con profonda conoscenza locale'
        },
        {
          title: 'Sicurezza Prima di Tutto',
          description: 'Massimi standard di sicurezza per tutte le escursioni'
        },
        {
          title: 'Prezzi Migliori',
          description: 'Prezzi competitivi senza compromettere la qualità'
        },
        {
          title: 'Servizio Personalizzato',
          description: 'Ogni escursione personalizzata secondo le tue esigenze'
        }
      ]
    },
    gallery: {
      title: 'La Nostra Galleria',
      subtitle: 'Uno Sguardo alla Tua Prossima Avventura'
    },
    testimonials: {
      title: 'Cosa Dicono i Nostri Clienti',
      subtitle: 'Esperienze Reali da Viaggiatori Reali',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Italia',
          rating: 5,
          text: 'Abbiamo scelto DREAM TOUR MARSA ALAM per organizzare le nostre escursioni a Marsa Alam (Super Safari, Hamata e Port Ghalib) e non potevamo fare scelta migliore! Si vede subito che svolge il suo lavoro con grande passione: sempre disponibile, gentilissima e pronta a rispondere a ogni nostra domanda con puntualità! L\'organizzazione è stata impeccabile: dal Safari mozzafiato all\'escursione in barca a Hamata, tutto curato nei minimi dettagli. Grazie a Karina abbiamo vissuto esperienze indimenticabili in totale serenità. Consigliatissima davvero❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Italia',
          rating: 5,
          text: 'Ci siamo affidati a DREAM TOUR MARSA ALAM per tutte le escursioni e non avremmo potuto fare scelta migliore. A Marsa Mubarak abbiamo visto i delfini e nuotato con un dugongo e le tartarughe marine. Luxor è stata magica, grazie alla supervisione di Hassan. Anche il Super Safari è stata una bellissima escursione. Karina è stata bravissima: sempre super attenta e disponibile per ogni domanda. Senza di lei e le sue escursioni la nostra vacanza non sarebbe stata la stessa e ogni escursione vale ogni centesimo speso.'
        },
        {
          name: 'Paola Franci',
          location: 'Italia',
          rating: 5,
          text: 'Ieri abbiamo fatto l\'escursione a Wadi El Gemal organizzata da DREAM TOUR MARSA ALAM. Abbiamo incontrato i delfini, nuotato con loro, raggiunto le lingue di sabbia e nuotato in un mare cristallino. Abbiamo incontrato una tartaruga, esplorato una barriera ricca e colorata, mangiato un ottimo pranzo. Una giornata magnifica. La nostra guida ha permesso di fare snorkeling a due ragazzi che non sapevano nuotare! Voto DIECIIIII!!! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Contattaci',
      subtitle: 'Siamo Qui per Aiutarti a Pianificare la Tua Avventura',
      form: {
        name: 'Nome',
        email: 'Email',
        phone: 'Telefono',
        message: 'Messaggio',
        submit: 'Invia Messaggio',
        success: 'Messaggio inviato con successo! Ti contatteremo presto.',
        error: 'Errore nell\'invio del messaggio. Riprova.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Gruppo Facebook'
      }
    },
    footer: {
      rights: 'Tutti i diritti riservati',
      followUs: 'Seguici'
    }
  },
  // POLISH
  pl: {
    nav: {
      home: 'Strona główna',
      tours: 'Wycieczki',
      about: 'O nas',
      gallery: 'Galeria',
      testimonials: 'Opinie',
      contact: 'Kontakt',
      quote: 'Zapytaj o cenę'
    },
    hero: {
      title: 'Witamy w Dream Tour',
      subtitle: 'Twoja brama do cudów Morza Czerwonego i Egiptu',
      cta: 'Odkryj nasze wycieczki',
      whatsapp: 'Kontakt przez WhatsApp'
    },
    tours: {
      title: 'Nasze wycieczki',
      subtitle: 'Wybierz swoją następną przygodę',
      clickInfo: 'Kliknij na ikony, aby zobaczyć pełny katalog',
      downloadCatalog: 'Pobierz pełny katalog',
      requestQuote: 'Zapytaj o cenę',
      seaTours: {
        title: 'Przygody morskie',
        tours: [
          {
            name: 'Pływanie z delfinami',
            description: 'Niesamowite doświadczenie pływania z delfinami w ich naturalnym środowisku',
            icon: 'dolphin'
          },
          {
            name: 'Spotkanie z żółwiami morskimi',
            description: 'Odkryj wspaniałe żółwie morskie w krystalicznie czystych wodach Morza Czerwonego',
            icon: 'turtle'
          },
          {
            name: 'Wyspy białego piasku',
            description: 'Odwiedź rajskie wyspy białego piasku z turkusowymi wodami',
            icon: 'island'
          },
          {
            name: 'Obserwacja diugoni',
            description: 'Wyjątkowa przygoda, aby zobaczyć rzadkie diugonie Morza Czerwonego',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Przygody pustynne',
        tours: [
          {
            name: 'Super Safari',
            description: 'Ekscytująca przygoda na pustyni quadem lub buggy',
            icon: 'desert'
          },
          {
            name: 'Podróż w historię',
            description: 'Odkryj cuda starożytnego Egiptu z przewodnikiem',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'O nas',
      subtitle: 'Twój punkt odniesienia w Marsa Alam',
      description: 'Jesteśmy oficjalnie zarejestrowaną agencją współpracującą z partnerami certyfikowanymi przez CDWS. Dzięki wieloletniemu doświadczeniu i głębokiej pasji do Egiptu i Morza Czerwonego, od lat tworzymy przygody, które pozostają w sercu.',
      features: [
        {
          title: 'Doświadczeni przewodnicy',
          description: 'Wielojęzyczni przewodnicy z głęboką wiedzą lokalną'
        },
        {
          title: 'Bezpieczeństwo przede wszystkim',
          description: 'Najwyższe standardy bezpieczeństwa dla wszystkich wycieczek'
        },
        {
          title: 'Najlepsze ceny',
          description: 'Konkurencyjne ceny bez kompromisów w jakości'
        },
        {
          title: 'Spersonalizowana obsługa',
          description: 'Każda wycieczka dostosowana do Twoich potrzeb'
        }
      ]
    },
    gallery: {
      title: 'Nasza galeria',
      subtitle: 'Rzut oka na Twoją następną przygodę'
    },
    testimonials: {
      title: 'Co mówią nasi klienci',
      subtitle: 'Prawdziwe doświadczenia prawdziwych podróżników',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Włochy',
          rating: 5,
          text: 'Wybraliśmy DREAM TOUR MARSA ALAM do organizacji naszych wycieczek w Marsa Alam (Super Safari, Hamata i Port Ghalib) i nie mogliśmy dokonać lepszego wyboru! Od razu widać, że pracują z wielką pasją: zawsze dostępni, bardzo mili i gotowi odpowiedzieć na każde pytanie! Organizacja była nienaganna. Gorąco polecam❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Włochy',
          rating: 5,
          text: 'Zaufaliśmy DREAM TOUR MARSA ALAM we wszystkich naszych wycieczkach i nie mogliśmy dokonać lepszego wyboru. W Marsa Mubarak widzieliśmy delfiny i pływaliśmy z diugoniem i żółwiami morskimi. Luxor był magiczny. Karina była doskonała: zawsze super uważna i dostępna na każde pytanie.'
        },
        {
          name: 'Paola Franci',
          location: 'Włochy',
          rating: 5,
          text: 'Wczoraj odbyliśmy wycieczkę do Wadi El Gemal zorganizowaną przez DREAM TOUR MARSA ALAM. Spotkaliśmy delfiny, pływaliśmy z nimi, dotarliśmy do piaszczystych łach i pływaliśmy w krystalicznie czystym morzu. Spotkaliśmy żółwia, zwiedziliśmy bogatą i kolorową rafę. Wspaniały dzień. Ocena DZIESIĘĆ NA DZIESIĘĆ!!! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Skontaktuj się z nami',
      subtitle: 'Jesteśmy tutaj, aby pomóc zaplanować Twoją przygodę',
      form: {
        name: 'Imię',
        email: 'Email',
        phone: 'Telefon',
        message: 'Wiadomość',
        submit: 'Wyślij wiadomość',
        success: 'Wiadomość wysłana pomyślnie! Skontaktujemy się wkrótce.',
        error: 'Błąd wysyłania wiadomości. Spróbuj ponownie.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Grupa Facebook'
      }
    },
    footer: {
      rights: 'Wszelkie prawa zastrzeżone',
      followUs: 'Śledź nas'
    }
  },
  // SPANISH
  es: {
    nav: {
      home: 'Inicio',
      tours: 'Excursiones',
      about: 'Nosotros',
      gallery: 'Galería',
      testimonials: 'Testimonios',
      contact: 'Contacto',
      quote: 'Solicitar presupuesto'
    },
    hero: {
      title: 'Bienvenidos a Dream Tour',
      subtitle: 'Tu puerta de acceso a las maravillas del Mar Rojo y Egipto',
      cta: 'Explora nuestras excursiones',
      whatsapp: 'Contactar por WhatsApp'
    },
    tours: {
      title: 'Nuestras excursiones',
      subtitle: 'Elige tu próxima aventura',
      clickInfo: 'Haz clic en los iconos para ver el catálogo completo',
      downloadCatalog: 'Descargar catálogo completo',
      requestQuote: 'Solicitar presupuesto',
      seaTours: {
        title: 'Aventuras marinas',
        tours: [
          {
            name: 'Nadar con delfines',
            description: 'Una experiencia increíble nadando con delfines en su hábitat natural',
            icon: 'dolphin'
          },
          {
            name: 'Encuentro con tortugas marinas',
            description: 'Descubre las maravillosas tortugas marinas en las aguas cristalinas del Mar Rojo',
            icon: 'turtle'
          },
          {
            name: 'Islas de arena blanca',
            description: 'Visita las paradisíacas islas de arena blanca con aguas turquesas',
            icon: 'island'
          },
          {
            name: 'Avistamiento de dugongos',
            description: 'Una aventura única para avistar los raros dugongos del Mar Rojo',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Aventuras en el desierto',
        tours: [
          {
            name: 'Super Safari',
            description: 'Emocionante aventura en el desierto con quad o buggy',
            icon: 'desert'
          },
          {
            name: 'Tour en la historia',
            description: 'Descubre las maravillas del antiguo Egipto con tours guiados',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'Nosotros',
      subtitle: 'Tu punto de referencia en Marsa Alam',
      description: 'Somos una agencia oficialmente registrada que colabora con socios certificados por CDWS. Gracias a una larga experiencia y a la profunda pasión por Egipto y el Mar Rojo, llevamos años creando aventuras destinadas a quedarse en el corazón.',
      features: [
        {
          title: 'Guías expertos',
          description: 'Guías multilingües con profundo conocimiento local'
        },
        {
          title: 'Seguridad ante todo',
          description: 'Máximos estándares de seguridad para todas las excursiones'
        },
        {
          title: 'Mejores precios',
          description: 'Precios competitivos sin comprometer la calidad'
        },
        {
          title: 'Servicio personalizado',
          description: 'Cada excursión personalizada según tus necesidades'
        }
      ]
    },
    gallery: {
      title: 'Nuestra galería',
      subtitle: 'Una mirada a tu próxima aventura'
    },
    testimonials: {
      title: 'Lo que dicen nuestros clientes',
      subtitle: 'Experiencias reales de viajeros reales',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Italia',
          rating: 5,
          text: 'Elegimos DREAM TOUR MARSA ALAM para organizar nuestras excursiones en Marsa Alam (Super Safari, Hamata y Port Ghalib) y no podríamos haber hecho una mejor elección. ¡Se nota inmediatamente que trabajan con gran pasión: siempre disponibles, muy amables y listos para responder a cada pregunta! La organización fue impecable. ¡Muy recomendado!❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Italia',
          rating: 5,
          text: 'Confiamos en DREAM TOUR MARSA ALAM para todas nuestras excursiones y no podríamos haber hecho una mejor elección. En Marsa Mubarak vimos delfines y nadamos con un dugongo y tortugas marinas. Luxor fue mágico. Karina fue excelente: siempre súper atenta y disponible para cualquier pregunta.'
        },
        {
          name: 'Paola Franci',
          location: 'Italia',
          rating: 5,
          text: 'Ayer hicimos la excursión a Wadi El Gemal organizada por DREAM TOUR MARSA ALAM. Encontramos delfines, nadamos con ellos, llegamos a los bancos de arena y nadamos en un mar cristalino. Encontramos una tortuga, exploramos un arrecife rico y colorido. Un día magnífico. ¡Calificación DIEZ DE DIEZ! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Estamos aquí para ayudarte a planificar tu aventura',
      form: {
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        message: 'Mensaje',
        submit: 'Enviar mensaje',
        success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
        error: 'Error al enviar el mensaje. Inténtalo de nuevo.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Grupo de Facebook'
      }
    },
    footer: {
      rights: 'Todos los derechos reservados',
      followUs: 'Síguenos'
    }
  },
  // FRENCH
  fr: {
    nav: {
      home: 'Accueil',
      tours: 'Excursions',
      about: 'À propos',
      gallery: 'Galerie',
      testimonials: 'Témoignages',
      contact: 'Contact',
      quote: 'Demander un devis'
    },
    hero: {
      title: 'Bienvenue chez Dream Tour',
      subtitle: 'Votre porte d\'accès aux merveilles de la Mer Rouge et de l\'Égypte',
      cta: 'Explorez nos excursions',
      whatsapp: 'Contactez-nous sur WhatsApp'
    },
    tours: {
      title: 'Nos excursions',
      subtitle: 'Choisissez votre prochaine aventure',
      clickInfo: 'Cliquez sur les icônes pour voir le catalogue complet',
      downloadCatalog: 'Télécharger le catalogue complet',
      requestQuote: 'Demander un devis',
      seaTours: {
        title: 'Aventures marines',
        tours: [
          {
            name: 'Nager avec les dauphins',
            description: 'Une expérience incroyable de nage avec les dauphins dans leur habitat naturel',
            icon: 'dolphin'
          },
          {
            name: 'Rencontre avec les tortues marines',
            description: 'Découvrez les merveilleuses tortues marines dans les eaux cristallines de la Mer Rouge',
            icon: 'turtle'
          },
          {
            name: 'Îles de sable blanc',
            description: 'Visitez les îles paradisiaques de sable blanc aux eaux turquoises',
            icon: 'island'
          },
          {
            name: 'Observation des dugongs',
            description: 'Une aventure unique pour observer les rares dugongs de la Mer Rouge',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Aventures dans le désert',
        tours: [
          {
            name: 'Super Safari',
            description: 'Aventure passionnante dans le désert en quad ou buggy',
            icon: 'desert'
          },
          {
            name: 'Tour dans l\'histoire',
            description: 'Découvrez les merveilles de l\'Égypte ancienne avec des visites guidées',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'À propos de nous',
      subtitle: 'Votre point de référence à Marsa Alam',
      description: 'Nous sommes une agence officiellement enregistrée qui collabore avec des partenaires certifiés CDWS. Grâce à une longue expérience et à une profonde passion pour l\'Égypte et la Mer Rouge, nous créons depuis des années des aventures destinées à rester dans le cœur.',
      features: [
        {
          title: 'Guides experts',
          description: 'Guides multilingues avec une connaissance locale approfondie'
        },
        {
          title: 'Sécurité avant tout',
          description: 'Normes de sécurité maximales pour toutes les excursions'
        },
        {
          title: 'Meilleurs prix',
          description: 'Prix compétitifs sans compromettre la qualité'
        },
        {
          title: 'Service personnalisé',
          description: 'Chaque excursion personnalisée selon vos besoins'
        }
      ]
    },
    gallery: {
      title: 'Notre galerie',
      subtitle: 'Un aperçu de votre prochaine aventure'
    },
    testimonials: {
      title: 'Ce que disent nos clients',
      subtitle: 'Expériences réelles de vrais voyageurs',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Italie',
          rating: 5,
          text: 'Nous avons choisi DREAM TOUR MARSA ALAM pour organiser nos excursions à Marsa Alam (Super Safari, Hamata et Port Ghalib) et nous n\'aurions pas pu faire un meilleur choix ! On voit tout de suite qu\'ils travaillent avec une grande passion : toujours disponibles, très gentils et prêts à répondre à chaque question ! L\'organisation était impeccable. Très recommandé❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Italie',
          rating: 5,
          text: 'Nous avons fait confiance à DREAM TOUR MARSA ALAM pour toutes nos excursions et nous n\'aurions pas pu faire un meilleur choix. À Marsa Mubarak, nous avons vu des dauphins et nagé avec un dugong et des tortues marines. Louxor était magique. Karina était excellente : toujours super attentive et disponible pour chaque question.'
        },
        {
          name: 'Paola Franci',
          location: 'Italie',
          rating: 5,
          text: 'Hier, nous avons fait l\'excursion à Wadi El Gemal organisée par DREAM TOUR MARSA ALAM. Nous avons rencontré des dauphins, nagé avec eux, atteint les bancs de sable et nagé dans une mer cristalline. Nous avons rencontré une tortue, exploré un récif riche et coloré. Une journée magnifique. Note DIX SUR DIX !!! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider à planifier votre aventure',
      form: {
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Envoyer le message',
        success: 'Message envoyé avec succès ! Nous vous contacterons bientôt.',
        error: 'Erreur lors de l\'envoi du message. Veuillez réessayer.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Groupe Facebook'
      }
    },
    footer: {
      rights: 'Tous droits réservés',
      followUs: 'Suivez-nous'
    }
  },
  // GERMAN
  de: {
    nav: {
      home: 'Startseite',
      tours: 'Ausflüge',
      about: 'Über uns',
      gallery: 'Galerie',
      testimonials: 'Bewertungen',
      contact: 'Kontakt',
      quote: 'Angebot anfordern'
    },
    hero: {
      title: 'Willkommen bei Dream Tour',
      subtitle: 'Ihr Tor zu den Wundern des Roten Meeres und Ägyptens',
      cta: 'Entdecken Sie unsere Ausflüge',
      whatsapp: 'Kontakt über WhatsApp'
    },
    tours: {
      title: 'Unsere Ausflüge',
      subtitle: 'Wählen Sie Ihr nächstes Abenteuer',
      clickInfo: 'Klicken Sie auf die Symbole, um den vollständigen Katalog anzuzeigen',
      downloadCatalog: 'Vollständigen Katalog herunterladen',
      requestQuote: 'Angebot anfordern',
      seaTours: {
        title: 'Meeresabenteuer',
        tours: [
          {
            name: 'Schwimmen mit Delfinen',
            description: 'Ein unglaubliches Erlebnis beim Schwimmen mit Delfinen in ihrem natürlichen Lebensraum',
            icon: 'dolphin'
          },
          {
            name: 'Begegnung mit Meeresschildkröten',
            description: 'Entdecken Sie die wunderbaren Meeresschildkröten im kristallklaren Wasser des Roten Meeres',
            icon: 'turtle'
          },
          {
            name: 'Weißsandinseln',
            description: 'Besuchen Sie paradiesische Weißsandinseln mit türkisfarbenem Wasser',
            icon: 'island'
          },
          {
            name: 'Dugong-Beobachtung',
            description: 'Ein einzigartiges Abenteuer, um die seltenen Dugongs des Roten Meeres zu beobachten',
            icon: 'magic'
          }
        ]
      },
      desertTours: {
        title: 'Wüstenabenteuer',
        tours: [
          {
            name: 'Super Safari',
            description: 'Aufregendes Wüstenabenteuer mit Quad oder Buggy',
            icon: 'desert'
          },
          {
            name: 'Tour in die Geschichte',
            description: 'Entdecken Sie die Wunder des alten Ägyptens mit geführten Touren',
            icon: 'pyramid'
          }
        ]
      }
    },
    about: {
      title: 'Über uns',
      subtitle: 'Ihr Ansprechpartner in Marsa Alam',
      description: 'Wir sind eine offiziell registrierte Agentur, die mit CDWS-zertifizierten Partnern zusammenarbeitet. Dank langjähriger Erfahrung und tiefer Leidenschaft für Ägypten und das Rote Meer schaffen wir seit Jahren Abenteuer, die im Herzen bleiben.',
      features: [
        {
          title: 'Erfahrene Guides',
          description: 'Mehrsprachige Guides mit tiefem lokalem Wissen'
        },
        {
          title: 'Sicherheit zuerst',
          description: 'Höchste Sicherheitsstandards für alle Ausflüge'
        },
        {
          title: 'Beste Preise',
          description: 'Wettbewerbsfähige Preise ohne Qualitätseinbußen'
        },
        {
          title: 'Personalisierter Service',
          description: 'Jeder Ausflug nach Ihren Bedürfnissen gestaltet'
        }
      ]
    },
    gallery: {
      title: 'Unsere Galerie',
      subtitle: 'Ein Blick auf Ihr nächstes Abenteuer'
    },
    testimonials: {
      title: 'Was unsere Kunden sagen',
      subtitle: 'Echte Erfahrungen von echten Reisenden',
      reviews: [
        {
          name: 'Federica Bosetti',
          location: 'Italien',
          rating: 5,
          text: 'Wir haben DREAM TOUR MARSA ALAM gewählt, um unsere Ausflüge in Marsa Alam zu organisieren (Super Safari, Hamata und Port Ghalib) und wir hätten keine bessere Wahl treffen können! Man sieht sofort, dass sie mit großer Leidenschaft arbeiten: immer verfügbar, sehr freundlich und bereit, jede Frage zu beantworten! Die Organisation war tadellos. Sehr empfehlenswert❤️'
        },
        {
          name: 'Ludovica Romito',
          location: 'Italien',
          rating: 5,
          text: 'Wir haben DREAM TOUR MARSA ALAM für alle unsere Ausflüge vertraut und hätten keine bessere Wahl treffen können. In Marsa Mubarak haben wir Delfine gesehen und sind mit einem Dugong und Meeresschildkröten geschwommen. Luxor war magisch. Karina war ausgezeichnet: immer super aufmerksam und für jede Frage verfügbar.'
        },
        {
          name: 'Paola Franci',
          location: 'Italien',
          rating: 5,
          text: 'Gestern haben wir den Ausflug nach Wadi El Gemal gemacht, organisiert von DREAM TOUR MARSA ALAM. Wir haben Delfine getroffen, sind mit ihnen geschwommen, haben die Sandbänke erreicht und sind im kristallklaren Meer geschwommen. Wir haben eine Schildkröte getroffen, ein reiches und farbenfrohes Riff erkundet. Ein großartiger Tag. Bewertung ZEHN VON ZEHN!!! ❤️❤️❤️'
        }
      ]
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir sind hier, um Ihnen bei der Planung Ihres Abenteuers zu helfen',
      form: {
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        message: 'Nachricht',
        submit: 'Nachricht senden',
        success: 'Nachricht erfolgreich gesendet! Wir werden Sie bald kontaktieren.',
        error: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.'
      },
      info: {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Facebook-Gruppe'
      }
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      followUs: 'Folgen Sie uns'
    }
  }
};

export const galleryImages = [
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/ugybiv0l_Hamata.jpeg', // Mare - Isola turchese
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/0up63ydy_Cairo.jpeg', // Terra - Piramidi e Sfinge
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/sd7ysc14_Granchio.jpeg', // Mare - Granchio sulla spiaggia
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/uq4u61os_Cavallo.jpeg', // Terra - Cavallo nel deserto
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/kb839ioz_Wadi%20el%20Gemal.jpeg', // Mare - Wadi el Gemal
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/cgusezqt_Occhiali%20Veloci.jpeg', // Terra - Quad nel deserto
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/31ysbf2w_Egittu.jpeg', // Mare - Barca con bandiera egiziana
  'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/b7t902yn_CinCin.jpeg' // Terra - Tè nel deserto al tramonto
];

export const catalogPdfUrl = 'https://customer-assets.emergentagent.com/job_sea-turtle-tours/artifacts/h62co17d_NUOVO%20LISTINO%20DREAM%20TOUR.pdf';
export const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLScmD2nqv78_B0imM2RAVQVd8DmmbqGx5_w0BhDUktRZVl1boA/viewform?usp=header';
export const whatsappNumber = '+393335682742';
export const instagramHandle = 'dream_tour_marsaalam';
export const facebookGroupUrl = 'https://www.facebook.com/share/g/1hVGGuUyAX/?mibextid=wwXIfr';